import React from "react";
import { Form, Select, Row, Col } from "antd";
import { useAtom } from "jotai";
import { anioAtom, filtroEstadoAtom, paginaActualAtom } from "../../ProgramarVacacionesStore";

const anioActual = new Date().getFullYear();
const OPCIONES_ANIO = [anioActual - 1, anioActual, anioActual + 1].map((a) => ({
    value: a,
    label: String(a),
}));

const FiltroProgramarVacaciones = () => {
    const [anio, setAnio] = useAtom(anioAtom);
    const [, setFiltroEstado] = useAtom(filtroEstadoAtom);
    const [, setPaginaActual] = useAtom(paginaActualAtom);
    const [form] = Form.useForm();

    const onChangeAnio = (value) => {
        setPaginaActual(1);
        setAnio(value);
    };

    const onChangeEstado = (value) => {
        setPaginaActual(1);
        setFiltroEstado(value);
    };

    return (
        <Form layout="vertical" form={form} initialValues={{ anio }}>
            <Row gutter={16}>
                <Col>
                    <Form.Item label="Año" name="anio">
                        <Select
                            style={{ width: 120 }}
                            options={OPCIONES_ANIO}
                            onChange={onChangeAnio}
                        />
                    </Form.Item>
                </Col>
                <Col>
                    <Form.Item label="Estado" name="estado">
                        <Select
                            style={{ width: 200 }}
                            placeholder="Todos los estados"
                            onChange={onChangeEstado}
                            allowClear
                        >
                            <Select.Option value="PENDIENTE">PENDIENTE</Select.Option>
                            <Select.Option value="APROBADO">APROBADO</Select.Option>
                            <Select.Option value="RECHAZADO">RECHAZADO</Select.Option>
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default FiltroProgramarVacaciones;
